import { useState, useEffect, useRef, memo } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import NewCategorylist from "../../components/CategoryTemplate/NewCategorylist";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
// import styles from "../transaction/transaction.module.css"
import styled from "styled-components"
import style from "../SellerDetails/Sellerdetails.module.css"
import brandStyles from "../Brand/Brand.module.css"
import styles from "./AddSubCategory.module.css"
import "../../components/mcrbTableTheme.css"
import { Link, useParams } from "react-router-dom"
import { CATEGORY_MAX_LENGTH, normalizeCategoryName, validateCategoryName } from "../../utils/categoryValidation";
import "../../index.css"
const { apiEndpoint } = config
var $ = require('jquery');
const CATEGORY_STATUS_KEY = "subcategory-status-draft";

const showCategoryApiError = (error, fallback = "Category request failed.") => {
    toast.error(error?.response?.data?.message || error?.message || fallback);
};

const Wrapper = styled.div
    `
padding: 10px;
display: flex;
flex-wrap: wrap


`
let arr = []
let Ndata = arr;
export default function AddSubCategory() {
    const decoded = tokenDecode();
    const { data } = decoded;
    const { permission: { category } } = data;
    const params = useParams();
    const [listing, setListing] = useState(true);
    let rawSubCatData = {
        parent_id: "",
        cat_name: "",
        status: true,
        id: ""
    }
    const [Subcategorydata, setSubcategorydata] = useState(() => ({
        ...rawSubCatData,
        status: localStorage.getItem(CATEGORY_STATUS_KEY) !== "false",
    }));
    const [subcat, setSubcat] = useState(false)
    const [subcattoggle, setSubcattoggle] = useState({});
    const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [listingLoading, setListingLoading] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectsub, setSelectsub] = useState(0);
    // const [catlist, setCatlist] = useState('');
    const [Nadata, setNadata] = useState([]);
    // const [isChecked, setIsChecked] = useState(false);
    console.log("subcattoggle-->", subcattoggle)
    const [tax, setTax] = useState({
        tax: '',
        status: true,
        id: ''
    });

    useEffect(() => {
        localStorage.setItem(CATEGORY_STATUS_KEY, String(Subcategorydata.status));
    }, [Subcategorydata.status]);

    const taxD = {
        tax: false,
        name: false,
        parent_id: false
    }
    const [taxErrorData, setTaxErrorData] = useState(taxD);
    const errorHandler = (e) => {
        const field = e.target.name === "cat_name" ? "name" : e.target.name;
        const normalizedValue = normalizeCategoryName(e.target.value);
        if (e.target.name === "cat_name") {
            setSubcategorydata((previousData) => ({ ...previousData, cat_name: normalizedValue }));
        } else {
            setTax((previousTax) => ({ ...previousTax, [e.target.name]: normalizedValue }));
        }
        setTaxErrorData({ ...taxErrorData, [field]: validateCategoryName(normalizedValue) });
    }
    const inputHandler = (e) => {
        setSelectsub(e.target.value);

    };

    const createTaxHandler = async () => {
        try {
            setLoading(true);
            const categoryName = normalizeCategoryName(tax?.tax);
            const validationMessage = validateCategoryName(categoryName);
            setTax((previousTax) => ({ ...previousTax, tax: categoryName }));
            setTaxErrorData({ ...taxErrorData, tax: validationMessage });
            if (!validationMessage) {
                const { data } = await axios({
                    url: `${apiEndpoint}/addcategorie`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        cat_name: categoryName,
                        status: tax.status
                    }
                });

                if (data.status === 200) {
                    toast.success("New Category created !", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTax({
                        tax: '',
                        status: true,
                        id: ''
                    })
                } else {
                    showCategoryApiError({ response: { data } });
                }
            } else {
                toast.error(validationMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            showCategoryApiError(error);
        }
    }

    const createSubCatHandler = async () => {

        console.log("data to send-->", Subcategorydata);
        const { parent_id, cat_name, status } = Subcategorydata
        try {
            setLoading(true);
            const categoryName = normalizeCategoryName(cat_name);
            const validationMessage = validateCategoryName(categoryName);
            setSubcategorydata((previousData) => ({ ...previousData, cat_name: categoryName }));
            setTaxErrorData({ ...taxErrorData, name: validationMessage });

            if (!validationMessage) {
                const { data } = await axios({
                    url: `${apiEndpoint}/ptaddsubcategories`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                    },
                    data: { product_cat_id: parent_id, name: categoryName, status: status }
                });

                if (data.status === 200) {
                    toast.success("New Sub Category created !");
                    taxListHanler();
                    setSubcategorydata(rawSubCatData)
                    localStorage.removeItem(CATEGORY_STATUS_KEY);
                } else {
                    showCategoryApiError({ response: { data } }, "Error in Payload!");
                }
            } else {
                toast.error(validationMessage);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            showCategoryApiError(error, "Server Error !");
        }
    }
    const taxListHanler = async () => {
        try {
            setListing(true);
            setSubcat(false)
            setListingLoading(true);

            const { data } = await axios({
                url: `${apiEndpoint}/ptgetcategories`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });

            setListingLoading(false);
            if (data.status === 200) {
                setTaxData(data.response);
            }

        } catch (error) {
            setListingLoading(false);


        }
    }

    const setCrete = () => {
        setListing(false);
        setIsUpdate(false);
        setSubcat(false);
        setTax({
            tax: '',
            status: true,
            id: ''
        })
    }
    const setsubCrete = async () => {
        setTax({
            tax: '',
            status: true,
            id: ''
        })
        setSubcategorydata(rawSubCatData)
        setListing(false);
        setIsUpdate(false);
        setSubcat(true);
        try {
            setListing(false);
            setListingLoading(false);
            const { data } = await axios({
                url: `${apiEndpoint}/getcategories`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            // console.log("tax listing", data);
            setListingLoading(false);
            if (data.status === 200) {
                Ndata = data.response;
                const parsedData = data.response.map(item => ({
                    id: item.id,
                    parent_id: item.parent_id,
                    cat_name: item.cat_name,
                    status: item.status,
                    subcategory: item.subcategory || []
                }));
                // console.log("parsed data-->", parsedData)
                setNadata(parsedData);


            }

        } catch (error) {
            setListingLoading(false);


        }
    }


    const editRedirect = async (id, parentCatName, isParentCategory) => {
        let endpointforCategoryView
        if (isParentCategory) {
            endpointforCategoryView = "ptcatsub"
        } else {
            endpointforCategoryView = "ptgetcatsub"
        }
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/${endpointforCategoryView}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "id": id
                }
            });
            if (!isParentCategory) {
                if (data.status === 200) {
                    setTax({
                        tax: data?.parent_id?.cat_name,
                        status: data?.parent_id?.status,
                        id: data?.parent_id?.id
                    });
                    setSubcategorydata({
                        parent_id: data?.parent_id?.parent_id,
                        cat_name: data?.parent_id?.cat_name,
                        status: data?.parent_id?.status,
                        id: data?.parent_id?.id
                    })
                    setSelectsub(data?.parent_id?.parent_id)
                    setCategoryDropdownOpen(true)
                }
            }

            if (isParentCategory) {
                if (data.status === 200) {
                    setTax({
                        tax: data?.parent_id[0]?.cat_name,
                        status: data?.parent_id[0]?.status,
                        id: data?.parent_id[0]?.id
                    });
                    setSubcategorydata({
                        parent_id: data?.parent_id[0]?.parent_id,
                        cat_name: data?.parent_id[0]?.cat_name,
                        status: data?.parent_id[0]?.status,
                        id: data?.parent_id[0]?.id
                    })
                    setSelectsub(data?.parent_id[0]?.parent_id)
                    setCategoryDropdownOpen(true)
                }
            }

        } catch (error) {

        }
        setIsUpdate(true);
        setListing(false);
        if (parentCatName !== "") {
            setSubcat(true)
        } else {
            setSubcat(false);
        }


    }


    const updateTax = async () => {
        try {
            if (tax?.tax) {
                const categoryName = normalizeCategoryName(tax?.tax);
                const validationMessage = validateCategoryName(categoryName);
                setTax((previousTax) => ({ ...previousTax, tax: categoryName }));
                setTaxErrorData({ ...taxErrorData, tax: validationMessage });
                if (validationMessage) {
                    toast.error(validationMessage);
                    return;
                }
                setLoading(true);
                console.log("tax", tax);
                const { data } = await axios({
                    url: `${apiEndpoint}/updatecategories`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        "cat_name": categoryName,
                        "status": tax.status,
                        id: tax.id
                    }
                });
                // console.log("data----", data);
                if (data.status === 200) {
                    toast.success("Category Updated !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    showCategoryApiError({ response: { data } });
                }
            } else {
                toast.error("Please fill the required field !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            showCategoryApiError(error);
        }
    }

    const updateSubTax = async () => {
        try {
            const categoryName = normalizeCategoryName(Subcategorydata?.cat_name);
            const validationMessage = validateCategoryName(categoryName);
            setSubcategorydata((previousData) => ({ ...previousData, cat_name: categoryName }));
            setTaxErrorData({ ...taxErrorData, name: validationMessage });
            if (!validationMessage) {
                setLoading(true);
                const { data } = await axios({
                    url: `${apiEndpoint}/updatesubcategories`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        "cat_name": categoryName,
                        "parent_id": Subcategorydata.parent_id,
                        id: Subcategorydata.id,
                        status: Subcategorydata.status
                    }
                });

                if (data.status === 200) {
                    toast.success("Category Updated !", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    showCategoryApiError({ response: { data } });
                }
            } else {
                toast.error("Please fill the required field !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            showCategoryApiError(error);
        }
    }

    const deleteTax = async (id, parent_id) => {
        try {
            setLoading(true);

            const { data } = await axios({
                url: `${apiEndpoint}/ptdelcatshiftsubcat`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { id, product_cat_id: parent_id }
            });
            if (data.status === 200) {
                toast.success("Category Deleted !");
                taxListHanler();
            } else {
                toast.error("403 Error !");
            }
        } catch (error) {
            toast.error("403 Error !");
        }
    }


    const handleSubcategoryChange = (id) => {
        setSubcategorydata({ ...Subcategorydata, parent_id: id });
    };

    const MakeCategory = memo(({ cat_name, subcategory, id, onSubcategoryChange, subcattoggle, setSubcattoggle, Subcategorydata, setSubcategorydata }) => {
        // debugger
        const subCategoryChecker = subcategory && subcategory.length > - 1;

        const handleCheckboxChange = () => {
            setSubcategorydata((prevState) => ({
                ...prevState,
                parent_id: prevState.parent_id === id ? null : id,
            }));
            onSubcategoryChange(id);
        };
        const handleToggleSubcategory = () => {
            setSubcattoggle((prevState) => ({ ...prevState, [id]: !prevState[id] }));
        };

        return (
            <>
                <div className="makeCategory_subCategory">
                    <ul className="my-0 category_list">
                        <li key={id}>
                            {subCategoryChecker && (
                                <span onClick={handleToggleSubcategory}>
                                    {subcattoggle[id] ? <RemoveIcon /> : <AddIcon />}
                                </span>
                            )}
                            <input
                                type="checkbox"
                                value={id}
                                onChange={handleCheckboxChange}
                                id={id}
                                checked={Subcategorydata.parent_id === id}
                            /> {cat_name}
                        </li>

                        {subCategoryChecker && subcattoggle[id] && (
                            <ul>
                                {subcategory.map((item) => (
                                    <MakeCategory
                                        {...item}
                                        key={item.id}
                                        onSubcategoryChange={onSubcategoryChange}
                                        subcattoggle={subcattoggle}
                                        setSubcattoggle={setSubcattoggle}
                                        Subcategorydata={Subcategorydata}
                                        setSubcategorydata={setSubcategorydata}
                                    />
                                ))}
                            </ul>
                        )}
                        <hr style={{ marginBottom: "0", marginTop: "0" }} />
                    </ul>
                </div>
            </>
        );
    });



    console.log(Nadata)

    useEffect(() => {
        taxListHanler()
        setsubCrete()
        if (params?.id) {
            editRedirect(params.id, "existing", false)
        }
    }, [])

    return (
        <ThemeMaker>
            <div className={`${brandStyles.pageWrap} mcrb-page`}>
                <div className={`${brandStyles.cardOuter} mcrb-card`}>
                    <div className={brandStyles.headerBar}>
                        <span className={brandStyles.title}>{isUpdate ? "Update Subcategory" : "Add Subcategory"}</span>
                        <Link to="/newcategory">
                            <button className={brandStyles.primaryBtn}>Category List</button>
                        </Link>
                    </div>

                    <div className={brandStyles.bodyArea}>
                        <div style={{ maxWidth: "640px" }}>

                            <div className={brandStyles.field}>
                                <label className={brandStyles.label}>
                                    Sub Category name<span className={brandStyles.required}>*</span>
                                </label>
                                {taxErrorData?.name ? (
                                    <span className={brandStyles.errorText}>{taxErrorData.name}</span>
                                ) : null}
                                <input
                                    type="text"
                                    className={brandStyles.input}
                                    name="cat_name"
                                    placeholder="Enter Sub Category Name.."
                                    maxLength={CATEGORY_MAX_LENGTH}
                                    value={Subcategorydata.cat_name}
                                    onChange={(e) => {
                                        setSubcategorydata({ ...Subcategorydata, [e.target.name]: e.target.value });
                                        setTaxErrorData({ ...taxErrorData, name: validateCategoryName(e.target.value) });
                                    }}
                                    onBlur={(e) => errorHandler(e)}
                                />
                            </div>

                            <div className={brandStyles.field}>
                                <label className={brandStyles.label}>Select Category</label>
                                <div className={styles.treeWrap}>
                                    <div className="subcategory">
                                        <div className="selectcategory" onClick={() => setCategoryDropdownOpen((isOpen) => !isOpen)}>Select Category <span style={{ "float": "right" }}>▼</span>
                                        </div>

                                        {
                                            categoryDropdownOpen && Nadata.map((item, index) => (
                                                <MakeCategory
                                                    {...item}
                                                    key={index}
                                                    onSubcategoryChange={handleSubcategoryChange}
                                                    subcattoggle={subcattoggle}
                                                    setSubcattoggle={setSubcattoggle}
                                                    Subcategorydata={Subcategorydata}
                                                    setSubcategorydata={setSubcategorydata}
                                                />
                                            ))
                                        }

                                    </div>
                                </div>

                            </div>

                            <div className={brandStyles.field}>
                                <label className={brandStyles.label}>Status</label>
                                <div className={brandStyles.statusRow}>
                                    <input type="checkbox" checked={Subcategorydata.status} name="status"
                                        className={brandStyles.checkbox}
                                        onChange={() => setSubcategorydata((previousData) => ({ ...previousData, status: !previousData.status }))}
                                    />
                                    <span style={{ fontSize: "13px", color: "#6B7280", fontWeight: 600 }}>
                                        {Subcategorydata.status ? "Active" : "Inactive"}
                                    </span>
                                </div>
                            </div>

                            <div>
                                {
                                    !isUpdate && !listing ? (
                                        <button type="submit" className={brandStyles.saveBtn}
                                            onClick={createSubCatHandler}
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button type="submit" className={brandStyles.updateBtn}
                                            onClick={updateSubTax}
                                        >
                                            Update
                                        </button>
                                    )
                                }
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </ThemeMaker >
    )
}
